const ruFlag = require("../assets/russia.png");
const enFlag = require("../assets/united-states.png");

export const USER_AUTH = "USER_AUTH";
export const USER_EMAIL = "USER_EMAIL";

export const timeDataRu = [
  { value: "", label: "За всё время" },
  { value: "1", label: "За день" },
  { value: "7", label: "За неделю" },
  { value: "30", label: "За месяц" },
];

export const timeDataEn = [
  { value: "", label: "During all this time" },
  { value: "1", label: "Last 24 hour" },
  { value: "7", label: "Last 1 week" },
  { value: "30", label: "Last 30 days" },
];

export const DeviceSize = {
  mobile: 768,
  tablet: 992,
  laptop: 1324,
  desktop: 2024,
};

export const SCAPTCHA_ONCOMPLETE_PROP: string = "SCAPTCHA_ONCOMPLETE";

export const locales = [
  {
    lang: "ru",
    title: "Русский",
    assets: ruFlag,
  },
  {
    lang: "en",
    title: "English",
    assets: enFlag,
  },
];

export const jsxExampleCodeRU = `
<script async="true" src="https://api.scaptcha.com/widget/scaptcha-ui.js" data-react-helmet="true"></script>
<div class="scaptcha_box">
 <div class="s-captcha" data-prop-sitekey=ОТКРЫТЫЙ_КЛЮЧ_САЙТА data-prop-oncomplete="SCAPTCHA_ONCOMPLETE">
  <input type="hidden" name="s-captcha-response" />
  …
  </div>
</div>
`;

export const jsxExampleCodeEN = `
<script async="true" src="https://api.scaptcha.com/widget/scaptcha-ui.js" data-react-helmet="true"></script>
<div class="scaptcha_box">
 <div class="s-captcha" data-prop-sitekey="OPEN_KEY" data-prop-oncomplete="SCAPTCHA_ONCOMPLETE">
  <input type="hidden" name="s-captcha-response" />
  …
  </div>
</div>
`;

export const pythonExampleCodeRU = `
SECRET_SCAPTCHA_TOKEN = "ЗАКРЫТЫЙ_КЛЮЧ_САЙТА"
scaptcha_url_check_token = "https://api.scaptcha.com/api/v2/verify_challenge" 
response_scaptcha = requests.post(
            scaptcha_url_check_token,
            params={"__root__": scaptcha_response_token},
            json={"domain_secret_key": secret_scaptcha_token},
        )
if response_scaptcha.status_code == 200:
      challenge_info = response_scpatcha.json()
      return challenge_info.get("status")
`;

export const pythonExampleCodeEN = `
SECRET_SCAPTCHA_TOKEN = "SECRET_KEY"
scaptcha_url_check_token = "https://api.scaptcha.com/api/v2/verify_challenge" 
response_scaptcha = requests.post(
            scaptcha_url_check_token,
            params={"__root__": scaptcha_response_token},
            json={"domain_secret_key": secret_scaptcha_token},
        )
if response_scaptcha.status_code == 200:
      challenge_info = response_scpatcha.json()
      return challenge_info.get("status")
`;
